import { useCallback } from "react"
import { useParams } from "react-router-dom"
import { Form } from "antd"
import { uniq } from "lodash"
// components
import { Switch } from "components-design-system"
import Loading from "components/Loading/Loading"
// apis
import { useUserSettings, usePostUserSettings } from "api/hooks"
import { useGetStudy } from "api/hooks/studies/useStudiesApi"

// styles
import "./Alerts.scss"

const Alerts = () => {
  const { studyId } = useParams()
  const { data: study } = useGetStudy(studyId)
  const { data: userSettings, isLoading: isUserSettingsLoading } = useUserSettings()
  const postUserSettings = usePostUserSettings()
  const [form] = Form.useForm()

  const updateUserSettings = useCallback(
    (temp) => {
      postUserSettings({ body: temp })
    },
    [postUserSettings]
  )

  const handleBlockedStudies = useCallback(
    (key, isBlocked) => {
      const updatedSettings = { ...userSettings }
      const blockedStudies = updatedSettings?.email_notification_settings?.[key]?.blocked_studies || []
      const studyIdToAdd = study?.study_id

      updatedSettings.email_notification_settings[key].blocked_studies = isBlocked
        ? blockedStudies.filter((id) => id !== studyIdToAdd)
        : uniq([...blockedStudies, studyIdToAdd])

      updateUserSettings(updatedSettings)
    },
    [userSettings, study?.study_id, updateUserSettings]
  )

  const onFormChange = (changedValues) => {
    const [key, value] = Object.entries(changedValues)[0]
    const isBlocked = value
    handleBlockedStudies(key, isBlocked)
  }

  const schema = [
    { title: "QA comment is received/added to study", key: "send_qa_comment_alert" },
    { title: "The anticipated date is in the past for a milestone", key: "send_anticipated_date_past_alert" },
    { title: "Potential Upcoming Initial Registration", key: "send_fpi_threshold_alert" },
    { title: "Potential Upcoming Primary Results Disclosure", key: "send_pcd_threshold_alert" },
    { title: "Potential Upcoming Final Results Disclosure", key: "send_lpo_threshold_alert" },
    { title: "Record Verification Date", key: "send_record_verification_update_alert" },
    { title: "Upcoming Activity Due Date any activity on the study", key: "send_upcoming_activity_alert" },
    { title: "Overdue Activity Due Date for any activity on the study", key: "send_overdue_activity_alert" },
    { title: "Automated Activities Created Digest", key: "send_automated_activities_alert" },
  ]

  const initialValues =
    userSettings && study
      ? schema.reduce((acc, { key }) => {
          const isBlocked = userSettings?.email_notification_settings?.[key]?.blocked_studies?.includes(study?.study_id)
          acc[key] = !isBlocked
          return acc
        }, {})
      : {}

  if (isUserSettingsLoading || !study) {
    return <Loading></Loading>
  }

  return (
    <div className="alerts-container">
      <Form
        form={form}
        initialValues={initialValues}
        onValuesChange={onFormChange}
      >
        <div className="title-container">
          <h1 className="title">Alerts</h1>
          <p className="subtitle">Configure your study alerts using the toggles below:</p>
        </div>
        {schema.map((item) => (
          <Form.Item
            key={item.key}
            name={item.key}
            valuePropName="checked"
            className="alert-item"
            wrapperCol={{ span: 12 }}
          >
            <Switch label={item.title} />
          </Form.Item>
        ))}
      </Form>
    </div>
  )
}

export default Alerts
